module.exports = __webpack_public_path__ + "img/Group_9.5a96fd5e.png";